/* nx-motion-core.js — ядрото на анимациите (собственик: A — ядро).
   Зарежда се с defer в <head> след gsap.min.js и ScrollTrigger.min.js; модулите (nx-motion-*.js)
   идват след него и се закачат само през NX.register — GSAP не се вика на горно ниво.

   window.NX = {
     flags:    { motion, fine, desktop }  — живи стойности; обновяват се при смяна на медията
     register(name, selector, init)       — init(el, flags) → cleanup?; this = gsap.context на елемента
     count(el, { to, from, duration, decimals, suffix, ease }) → tween
   }
   Плюс разкриването при скрол (.reveal/.fade/.mask/.lines): ScrollTrigger решава КОГА,
   самата анимация са CSS преходите от nexum.css (GSAP не пипа transform/opacity на тези елементи). */
(function (win, doc) {
  'use strict';
  if (win.__nxCore) return;
  win.__nxCore = true;

  var html = doc.documentElement;
  var gsap = win.gsap, ST = win.ScrollTrigger;
  var ok = !!(gsap && ST && gsap.matchMedia && gsap.context);
  var REVEAL = '.reveal,.fade,.mask,.lines';
  var Q = { motion: '(prefers-reduced-motion: no-preference)', fine: '(pointer: fine)', desktop: '(min-width: 900px)' };
  var LIM = 0.92;                                   // = start 'top 92%' на партидите

  function mq(q) { return !!(win.matchMedia && win.matchMedia(q).matches); }
  function arr(l) { return Array.prototype.slice.call(l || []); }
  function vh() { return win.innerHeight || html.clientHeight || 0; }
  function editor() { return !!(win.Shopify && win.Shopify.designMode); }
  function warn(what, err) { if (win.console) console.error('[NX] ' + what, err); }
  // елементите в scope + самия scope, ако съвпада
  function find(scope, sel) {
    var out = arr(scope.querySelectorAll(sel));
    if (scope.nodeType === 1 && scope.matches(sel)) out.unshift(scope);
    return out;
  }

  var flags = { motion: mq(Q.motion), fine: mq(Q.fine), desktop: mq(Q.desktop) };


  /* ---------- 1. Разкриване при скрол ---------- */
  var pending = [], batches = [];

  function baseDelay(el) {                          // .d1/.d2/.d3 от nexum.css — пазим намерението им
    var c = el.classList;
    return c.contains('d3') ? 300 : c.contains('d2') ? 200 : c.contains('d1') ? 100 : 0;
  }

  // .lines: щом редовете влязат, махаме клипа — иначе опашките на у, р, д, щ се режат
  function releaseLines(el) {
    var spans = arr(el.querySelectorAll('.ln > span')), seen = [], t;
    if (!spans.length || !flags.motion) { el.classList.add('nx-done'); return; }
    function done() {
      clearTimeout(t);
      el.removeEventListener('transitionend', on);
      el.removeEventListener('animationend', on);
      el.classList.add('nx-done');
    }
    function on(e) {
      if (spans.indexOf(e.target) < 0 || seen.indexOf(e.target) > -1) return;
      seen.push(e.target);
      if (seen.length === spans.length) done();
    }
    el.addEventListener('transitionend', on);
    el.addEventListener('animationend', on);
    t = setTimeout(done, 2600);                     // резерв: преходът може и да не тръгне
  }

  // i = място в партидата → стъпка от 80 ms (но не по-малко от .d1/.d2/.d3)
  function show(el, i) {
    var k = pending.indexOf(el);
    if (k > -1) pending.splice(k, 1);
    if (el.classList.contains('is-visible')) return;
    var base = baseDelay(el), ms = Math.max((i || 0) * 80, base);
    if (ms) el.style.setProperty('--nx-d', ms + 'ms');   // маркерът вътре тръгва 250 ms след това
    if (ms > base) {
      el.style.transitionDelay = ms + 'ms';
      // после махаме закъснението — да не забавя hover преходите на същия елемент
      setTimeout(function () { el.style.transitionDelay = ''; }, ms + 1300);
    }
    el.classList.add('is-visible');
    if (el.classList.contains('lines')) releaseLines(el);
  }

  function revealIn(scope, now) {
    var els = find(scope, REVEAL).filter(function (el) {
      return !el.classList.contains('is-visible') && pending.indexOf(el) < 0;
    });
    if (!els.length) return;
    if (now || !ok || !flags.motion) { els.forEach(function (el) { show(el, 0); }); return; }
    // първо четем всички позиции, после пишем класове
    var lim = vh() * LIM;
    var tops = els.map(function (el) { return el.getBoundingClientRect().top; });
    var later = els.filter(function (el, n) { return tops[n] >= lim; });
    // над сгъвката или вече подминато (презареждане по средата, котва) — веднага, без закъснение
    els.forEach(function (el, n) { if (tops[n] < lim) show(el, 0); });
    if (!later.length) return;
    pending.push.apply(pending, later);
    batches.push.apply(batches, ST.batch(later, {
      once: true,
      start: 'top 92%',
      onEnter: function (b) { b.forEach(show); },                            // show(el, i)
      onLeave: function (b) { b.forEach(function (el) { show(el, 0); }); }  // прескочено при бърз скрол
    }));
  }

  // резерв като стария catchUp: всичко чакащо, което вече е над долната граница
  function catchUp() {
    if (!pending.length) return;
    var lim = vh() * LIM;
    pending.filter(function (el) { return el.getBoundingClientRect().top < lim; })
      .forEach(function (el) { show(el, 0); });
  }

  function unrevealIn(scope) {
    batches = batches.filter(function (st) {
      if (!scope.contains(st.trigger)) return true;
      st.kill();
      return false;
    });
    pending = pending.filter(function (el) { return !scope.contains(el); });
  }


  /* ---------- 2. Регистър на модулите ---------- */
  var regs = [], insts = [], live = false;

  function stop(inst) {
    try { if (inst.ctx) inst.ctx.revert(); } catch (e) { warn(inst.reg.name + ': revert', e); }
    try { if (typeof inst.off === 'function') inst.off(); } catch (e) { warn(inst.reg.name + ': cleanup', e); }
    var own = inst.el.__nx, k = own ? own.indexOf(inst.reg) : -1;
    if (k > -1) own.splice(k, 1);
  }

  function start(reg, el) {
    var own = el.__nx || (el.__nx = []);
    if (own.indexOf(reg) > -1) return;              // вече е пуснат за този елемент
    own.push(reg);
    var inst = { reg: reg, el: el, ctx: null, off: null, err: null };
    inst.ctx = gsap.context(function () {
      // хващаме грешката ВЪТРЕ в контекста — иначе gsap остава със „закачен" текущ контекст
      try { inst.off = reg.init.call(this, el, flags); } catch (e) { inst.err = e; }
    });
    if (inst.err) { warn(reg.name + ': init', inst.err); stop(inst); return; }
    insts.push(inst);
  }

  function runIn(scope, only) {
    (only ? [only] : regs).forEach(function (reg) {
      var els;
      try { els = find(scope, reg.selector); } catch (e) { warn(reg.name + ': selector', e); return; }
      els.forEach(function (el) { start(reg, el); });
    });
  }

  // в обратен ред — по-късно пуснатото може да стъпва на по-ранното; scope = null → всички
  function stopIn(scope) {
    for (var i = insts.length - 1; i >= 0; i--) {
      if (!scope || scope.contains(insts[i].el)) { stop(insts[i]); insts.splice(i, 1); }
    }
  }

  function register(name, selector, init) {
    if (typeof init !== 'function' || !selector) return;
    var reg = { name: String(name), selector: selector, init: init };
    regs.push(reg);
    if (live) runIn(doc, reg);                      // след DOMContentLoaded — веднага
  }


  /* ---------- 3. Брояч ---------- */
  function numOf(s) {
    var m = String(s).replace(/[\s\u00a0\u202f]/g, '').match(/-?\d+(?:[.,]\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : NaN;
  }

  // крайната стойност вече е в HTML-а; при revert (смяна на флаг, unload) я връщаме точно такава
  function count(el, o) {
    o = o || {};
    var orig = el.__nxText != null ? el.__nxText : (el.__nxText = el.textContent);
    var to = o.to != null ? +o.to : numOf(orig);
    var from = +(o.from || 0), dec = Math.max(0, o.decimals | 0), suffix = o.suffix || '';
    var comma = /\d,\d/.test(orig);                                        // „4,9" — десетична запетая
    var grp = (orig.match(/\d([ \u00a0\u202f])\d{3}(?!\d)/) || [])[1] || '';  // „12 000"
    function fmt(v) {
      var s = (+v).toFixed(dec).split('.');
      if (grp) s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp);
      return s.join(comma ? ',' : '.') + suffix;
    }
    var p = { v: from };
    if (isNaN(to)) return gsap.to(p, { v: from, duration: 0 });
    var end = numOf(orig) === to ? orig : fmt(to);
    // скрит таб: кадрите спират и броенето би замръзнало на „0" — тогава показваме крайното число направо
    if (!flags.motion || doc.hidden) { el.textContent = end; return gsap.to(p, { v: to, duration: 0 }); }
    // табът се скрие по средата → скачаме до края, вместо да оставим междинно число
    var onVis = function () { if (doc.hidden && tw.isActive()) tw.progress(1); };
    var done = function () { el.textContent = end; doc.removeEventListener('visibilitychange', onVis); };
    var tw = gsap.to(p, {
      v: to,
      duration: o.duration != null ? +o.duration : 1.1,
      ease: o.ease || 'power2.out',
      onUpdate: function () { el.textContent = fmt(p.v); },
      onComplete: done,
      onInterrupt: done
    });
    doc.addEventListener('visibilitychange', onVis);
    // текстът не е CSS свойство и gsap не го помни — revert-ът на контекста минава оттук
    var rv = tw.revert;
    tw.revert = function () { var r = rv.apply(tw, arguments); doc.removeEventListener('visibilitychange', onVis); el.textContent = orig; return r; };
    return tw;
  }


  /* ---------- 4. Лентата за прогрес стои точно под фиксираната навигация ---------- */
  function navBar() {
    var nav = doc.getElementById('nav');
    if (!nav || !doc.querySelector('.nx-progress')) return;
    var set = function (h) { html.style.setProperty('--nx-nav-h', h + 'px'); };
    set(nav.offsetHeight);
    if (win.ResizeObserver) new ResizeObserver(function (en) {
      var b = en[0] && en[0].borderBoxSize;
      set(b && b[0] ? b[0].blockSize : nav.offsetHeight);
    }).observe(nav);
  }


  /* ---------- 5. Старт ---------- */
  var booted = false;

  function boot() {
    if (booted) return;
    booted = true;
    win.__nxBooted = true;                          // спира 3-секундния резерв от snippets/nx-motion.liquid
    navBar();
    if (!ok) { revealIn(doc, true); return; }       // без GSAP — всичко видимо веднага

    // модулите — в gsap.matchMedia: смяна на кой да е флаг → всичко се връща и се пуска наново.
    // „on: all" държи функцията активна и когато трите флага са false (иначе gsap изобщо не я вика).
    gsap.matchMedia().add({ on: 'all', motion: Q.motion, fine: Q.fine, desktop: Q.desktop }, function (c) {
      var k = c.conditions;
      flags.motion = !!k.motion; flags.fine = !!k.fine; flags.desktop = !!k.desktop;
      live = true;
      runIn(doc);
      return function () { live = false; stopIn(null); };
    });

    // разкриването — СЛЕД модулите, за да са вече вътре pin-spacer-ите им
    revealIn(doc, editor());
    ST.addEventListener('scrollEnd', catchUp);
    ST.addEventListener('refresh', catchUp);

    doc.addEventListener('shopify:section:load', function (e) {
      var s = e.target;
      if (!s || !s.querySelectorAll) return;
      if (live) runIn(s);
      revealIn(s, editor());
      ST.refresh();
    });
    doc.addEventListener('shopify:section:unload', function (e) {
      var s = e.target;
      if (!s || !s.contains) return;
      stopIn(s);
      unrevealIn(s);
      setTimeout(function () { ST.refresh(); }, 0); // след като секцията реално е извадена
    });

    var refresh = function () { if (ST.sort) ST.sort(); ST.refresh(); };
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(refresh);
    if (doc.readyState === 'complete') refresh(); else win.addEventListener('load', refresh);
  }

  if (ok) {
    gsap.registerPlugin(ST);
    ST.config({ ignoreMobileResize: true });
    html.classList.add('nx-gsap');
    win.NX = { flags: flags, register: register, count: count };
  }
  // defer скриптовете вървят ПРЕДИ DOMContentLoaded → модулите след ядрото влизат в опашката
  if (doc.readyState === 'complete') boot();
  else { doc.addEventListener('DOMContentLoaded', boot); win.addEventListener('load', boot); }
})(window, document);
